module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Moon Cutters")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/styles.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "books-by-head"
  }, [_c('em', [_vm._v("Recent Titles by Janet Woods from Severn House")])]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("AMARANTH MOON")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("BROKEN JOURNEY")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("CINNAMON SKY")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("THE COAL GATHERER")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("EDGE OF REGRET")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("HEARTS OF GOLD")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("LADY LIGHTFINGERS")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("I’LL GET BY")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("MOON CUTTERS")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("MORE THAN A PROMISE")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("PAPER DOLL")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("SALTING THE WOUND")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("SECRETS AND LIES")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("THE STONECUTTER’S DAUGHTER")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("STRAW IN THE WIND")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("TALL POPPIES")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("WITHOUT REPROACH")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15742380","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/alsoby.vue
// module id = 63
// module chunks = 0